import {RecipientType} from "types/global";
import {EmailNotificationChannelLogRecipientDto,} from "../types/notifications";

export const resolveSomeTrueValue = (deps: boolean[]) => deps.some((v) => v);

export const intersect = (first: unknown[], second: unknown[]) => first.some((v) => second.includes(v));

export const prepareKeys = <T = unknown>(items: T[]) => {
    let count = 0;

    return items.map((item) => ({
        item,
        key: String(++count),
    }));
};

export const generateQueryParams = (params?: Record<string, string | number | boolean | null | undefined>) => {
    if (!params) return '';

    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            searchParams.append(key, String(value));
        }
    });

    const query = searchParams.toString();
    return query ? `?${query}` : '';
};


export const generateRoute = (path: string, params: Record<string, string | number>) => {
    return path.replace(/:([a-zA-Z]+)/g, (_, key) => {
        const value = params[key];
        if (value === undefined) {
            throw new Error(`Missing parameter: ${key}`);
        }
        return String(value);
    });
}


export const generateGroupedRecipients = (recipients: EmailNotificationChannelLogRecipientDto[]): Partial<Record<RecipientType, string>> => {
    const tempMap: Record<RecipientType, string[]> = {
        TO: [],
        CC: [],
        BCC: [],
    };

    // Recipients with a missing or unknown type still belong on the TO line
    // rather than silently disappearing from the details page.
    recipients.forEach(({recipientEmail, recipientType}) => {
        (tempMap[recipientType] ?? tempMap.TO).push(recipientEmail);
    });

    const result: Partial<Record<RecipientType, string>> = {};

    (Object.keys(tempMap) as RecipientType[]).forEach((type) => {
        if (tempMap[type].length > 0) {
            result[type] = tempMap[type].join(', ');
        }
    });

    return result;
}